/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ACTIVATABLE_IN_BATTLE_ROOM = (
    <FormattedMessage
        id='toolbar.activatable_in_battle_room'
        defaultMessage='Устанавливаются перед боем'
    />
)

export const RESERVE_TOOLTIP_ID = 'toolbar.reserve_tooltip'



// WEBPACK FOOTER //
// ./containers/Stronghold/components/Toolbar/constants.jsx